export const IMAGES = {
  hero: "/images/hero-stairlift.jpg",
  straight: "/images/product-straight.jpg",
  curved: "/images/product-curved.jpg",
  outdoor: "/images/product-outdoor.jpg",
  cdrive: "/images/cdrive-motor.jpg",
  wsafe: "/images/wsafe-detail.jpg",
  factory: "/images/factory-rail.jpg",
  aimeasure: "/images/aimeasure-staircase.jpg",
  architecture:
    "https://images.unsplash.com/photo-1728204096996-bf15cb158779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBtaW5pbWFsJTIwaW50ZXJpb3IlMjBlbGV2YXRvciUyMHN0YWlybGlmdCUyMGluZHVzdHJpYWwlMjBkZXNpZ258ZW58MHx8fHwxNzg3NjQwMzg0fDA&ixlib=rb-4.1.0&q=85",
  roboticAssembly:
    "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZW5naW5lZXJpbmclMjBtYW51ZmFjdHVyaW5nJTIwcHJlY2lzaW9uJTIwZmFjdG9yeSUyMHJvYm90aWNzJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3ODc2NDAzODV8MA&ixlib=rb-4.1.0&q=85",
  controlRoom:
    "https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  machining:
    "https://images.pexels.com/photos/34207359/pexels-photo-34207359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PRODUCTS = [
  {
    slug: "active-straight",
    name: "ACTIVE Straight",
    code: "ASL-100",
    tagline: "Simple. Reliable. Silent.",
    image: IMAGES.straight,
    gallery: [IMAGES.straight, IMAGES.cdrive, IMAGES.factory],
    tech: ["CDRIVE™"],
    description:
      "The definitive straight stairlift platform. A slim 60 mm rail, a brushless CDRIVE™ powertrain and a seat that folds to 280 mm — engineered for fast installation and decades of silent service.",
    highlights: [
      "The quietest drive in its class at 38 dB",
      "Slim 60 mm anodised aluminium rail",
      "Installs in under 3 hours, left or right side",
      "Folds to 280 mm from the wall",
    ],
    benefits: [
      { title: "Absolute silence", text: "CDRIVE™ brushless motor removes brushes, gears and vibration — just a smooth, silent glide." },
      { title: "Fast installation", text: "Modular rail sections and a self-calibrating controller cut dealer install time dramatically." },
      { title: "Minimal footprint", text: "Seat, arms and footrest fold flat, leaving the staircase free for everyone else." },
      { title: "Dealer-friendly service", text: "Tool-free access panels and remote-ready diagnostics reduce callouts." },
    ],
    specs: [
      { label: "Rated noise level", value: "38 dB" },
      { label: "Maximum user weight", value: "160 kg (opt. 200 kg)" },
      { label: "Rail profile", value: "60 mm anodised aluminium" },
      { label: "Travel speed", value: "0.12 m/s soft-start" },
      { label: "Drive system", value: "CDRIVE™ 24V DC brushless" },
      { label: "Folded width", value: "280 mm from wall" },
      { label: "Power", value: "Continuous-charge batteries, 230V mains" },
      { label: "Certification", value: "EN 81-40 · CE" },
    ],
    faqs: [
      { q: "Which staircases does ACTIVE Straight fit?", a: "Any straight staircase without landings or turns, indoors, mounted on either side. Rail length is cut to order in our European facility." },
      { q: "How long does installation take?", a: "A trained two-person dealer team completes a standard installation in under three hours, including commissioning and user handover." },
      { q: "Can it be supplied under our own brand?", a: "Yes. ACTIVE Straight is available as a full OEM product — your colours, your badge, your documentation, your packaging." },
      { q: "What warranty do dealers receive?", a: "A 5-year drivetrain and 2-year full-product warranty as standard, with extended programmes for distribution partners." },
    ],
  },
  {
    slug: "active-curved",
    name: "ACTIVE Curved",
    code: "ACL-200",
    tagline: "Smooth. Compact. Precise.",
    image: IMAGES.curved,
    gallery: [IMAGES.curved, IMAGES.architecture, IMAGES.cdrive],
    tech: ["CDRIVE™"],
    description:
      "A twin-rail curved platform manufactured to the millimetre for every staircase. Complex turns, spirals and intermediate landings — resolved with premium European engineering.",
    highlights: [
      "Custom twin rail, bent to your survey data",
      "Handles spirals, fans and multi-landing stairs",
      "Automatic swivel and powered folding options",
      "38 dB CDRIVE™ ride quality on every curve",
    ],
    benefits: [
      { title: "Made to measure", text: "Every rail is CNC-bent in Europe from photographic survey data — no compromises, no site modification." },
      { title: "Complex staircase capability", text: "180° turns, spiral flights and split landings are standard work, not special projects." },
      { title: "Compact parking", text: "Hinged rail and park-point options keep hallways and doorways completely clear." },
      { title: "Premium ride", text: "Level-travel seat compensation keeps the chair perfectly horizontal through every bend." },
    ],
    specs: [
      { label: "Rated noise level", value: "38 dB" },
      { label: "Maximum user weight", value: "160 kg" },
      { label: "Rail system", value: "Custom twin rail, CNC-bent" },
      { label: "Minimum stair width", value: "640 mm" },
      { label: "Drive system", value: "CDRIVE™ 24V DC brushless" },
      { label: "Options", value: "Powered swivel · powered footrest · hinged rail" },
      { label: "Survey input", value: "Photo survey (AIMEASURE™ ready)" },
      { label: "Certification", value: "EN 81-40 · CE" },
    ],
    faqs: [
      { q: "How is the rail measured and produced?", a: "Dealers survey the staircase photographically. Our engineering team generates the rail geometry and CNC-bends it in our European facility — ready for AIMEASURE™ full automation." },
      { q: "What is the production lead time?", a: "Standard curved rails ship in 15 working days from survey approval, express in 7." },
      { q: "Can the chair park away from the stairs?", a: "Yes. Programmable park points and a bottom hinged rail keep corridors and doorways clear." },
      { q: "Is OEM branding available on curved models?", a: "Fully — rail colours, seat upholstery, badging, manuals and packaging can all carry your brand." },
    ],
  },
  {
    slug: "active-outdoor-curved",
    name: "ACTIVE Outdoor Curved",
    code: "AOC-300",
    tagline: "Every season. Every curve.",
    image: IMAGES.outdoor,
    gallery: [IMAGES.outdoor, IMAGES.wsafe, IMAGES.factory],
    tech: ["CDRIVE™", "WSAFE™"],
    description:
      "The world's only outdoor curved stairlift. WSAFE™ protection shields every board, bearing and connector from rain, UV and corrosion — a category your competitors cannot offer.",
    highlights: [
      "The world's only outdoor curved stairlift",
      "WSAFE™ sealed electronics and connectors",
      "UV-stabilised, corrosion-proof materials",
      "Rated −15°C to +45°C, all-year reliability",
    ],
    benefits: [
      { title: "A category of one", text: "Curved outdoor staircases were unservable — until now. Offer what no competitor can." },
      { title: "WSAFE™ engineering", text: "Sealed housings, marine-grade fasteners and conformal-coated boards engineered for every season." },
      { title: "All-weather confidence", text: "Tested through rain, frost, salt air and direct summer sun for continuous outdoor duty." },
      { title: "Protective cover included", text: "A tailored weather cover and lockable key switch protect the unit when not in use." },
    ],
    specs: [
      { label: "Rated noise level", value: "38 dB" },
      { label: "Maximum user weight", value: "160 kg" },
      { label: "Protection rating", value: "WSAFE™ · IPX4 electronics" },
      { label: "Operating range", value: "−15°C to +45°C" },
      { label: "Materials", value: "UV-stabilised, marine-grade fixings" },
      { label: "Drive system", value: "CDRIVE™ 24V DC brushless" },
      { label: "Included", value: "Weather cover · key switch · surge protection" },
      { label: "Certification", value: "EN 81-40 · CE" },
    ],
    faqs: [
      { q: "Is it really the only outdoor curved stairlift?", a: "To our knowledge, yes — ACTIVE Outdoor Curved is the only stairlift engineered from the ground up for curved outdoor staircases." },
      { q: "How does it survive winter?", a: "WSAFE™ electronics are conformal-coated and sealed to IPX4, batteries are temperature-managed, and all materials are UV and corrosion resistant." },
      { q: "What maintenance does it need outdoors?", a: "An annual dealer service. The brushless CDRIVE™ drivetrain has no brushes to replace and no gearbox oil to change." },
      { q: "Can we offer it under our brand?", a: "Yes — the outdoor platform is available for OEM and ODM partners, including exclusive territory agreements." },
    ],
  },
];

export const FUTURE_TECH = [
  {
    slug: "modular-rail",
    name: "MODULAR RAIL™",
    tagline: "The Future of Stairlift Rail Systems.",
    text: "ACTIVE is developing a revolutionary modular rail platform that will change how curved stairlifts are specified, produced and installed. Technical details remain confidential.",
  },
  {
    slug: "aimeasure",
    name: "AIMEASURE™",
    tagline: "AI Photographic Stair Measurement.",
    text: "Take photographs. Generate the staircase. Generate the rail automatically. No laser scanner, no expensive equipment — just smartphone photography.",
  },
  {
    slug: "active-connect",
    name: "ACTIVE CONNECT™",
    tagline: "Remote Diagnostics & Fleet Management.",
    text: "Dealer connectivity across the entire installed fleet: remote diagnostics, status monitoring and proactive service triggers.",
  },
  {
    slug: "active-care",
    name: "ACTIVE CARE™",
    tagline: "Predictive Maintenance & Service Platform.",
    text: "Predictive maintenance, warranty management and a complete service platform connecting dealers, end users and the factory.",
  },
];

export const WHY_ACTIVE = [
  { title: "CDRIVE™", text: "Proprietary brushless drive. The quietest stairlift in the world at 38 dB.", big: true, dark: true },
  { title: "WSAFE™", text: "Outdoor protection technology. The world's only outdoor curved stairlift.", big: true, dark: false },
  { title: "Straight Stairlift", text: "Simple, reliable, silent — the volume product every range needs." },
  { title: "Curved Stairlift", text: "Custom twin-rail engineering for any staircase geometry." },
  { title: "Outdoor Curved", text: "A category of one. Serve staircases competitors must refuse." },
  { title: "European Manufacturing", text: "European rail production. Fast delivery. Future modular rail." },
  { title: "OEM Manufacturing", text: "Your brand, our platform. Complete private-label production." },
  { title: "ODM Development", text: "From sketch to mass production — your own stairlift, engineered." },
  { title: "AI Dealer Platform", text: "Marketing, CRM, automation and photo measurement — built for dealers.", big: true, dark: false },
];

export const DISTRIBUTOR_REASONS = [
  { title: "Better margins", text: "Factory-direct European pricing structured for distributor profitability." },
  { title: "Premium quality", text: "Products that win the showroom comparison — and the reference visit." },
  { title: "Fast production", text: "Straight rails in days, custom curved rails in 15 working days." },
  { title: "European engineering", text: "EN 81-40 certified, CE marked, manufactured in Europe." },
  { title: "OEM support", text: "Full private-label programme: colours, badging, manuals, packaging." },
  { title: "ODM support", text: "Co-develop exclusive products your competitors cannot source." },
  { title: "Marketing support", text: "Campaign assets, renders, video and co-branded launch material." },
  { title: "CRM integration", text: "Leads, quotes and service flow straight into your pipeline." },
  { title: "AI tools", text: "AIMEASURE™ photo surveys and automation that cut cost per install." },
  { title: "Training & technical assistance", text: "Academy programmes, certification and factory-level engineering support." },
];

export const INDUSTRIES = [
  { name: "Accessibility", text: "Specialist accessibility companies expanding into a premium European range.", icon: "Accessibility" },
  { name: "Healthcare", text: "Healthcare suppliers adding home-mobility products to their portfolio.", icon: "HeartPulse" },
  { name: "Medical Equipment", text: "Medical equipment distributors seeking certified, silent stairlift platforms.", icon: "Stethoscope" },
  { name: "Elevator Companies", text: "Lift and elevator firms extending vertical mobility to staircases.", icon: "Building2" },
  { name: "Government", text: "Public procurement and government suppliers requiring European certification.", icon: "Landmark" },
  { name: "Rental", text: "Rental and reconditioning operators needing durable, serviceable platforms.", icon: "Recycle" },
  { name: "Importers", text: "National importers building exclusive territories around a manufacturing partner.", icon: "Ship" },
  { name: "Distribution Groups", text: "Large purchasing groups consolidating volume with a single platform factory.", icon: "Network" },
];

export const DOWNLOADS = [
  { name: "Dealer Catalogue", type: "PDF · 48 pages", desc: "Complete product range, specifications and dealer programme." },
  { name: "OEM Presentation", type: "PDF · 24 pages", desc: "Private-label manufacturing capabilities and process." },
  { name: "ODM Presentation", type: "PDF · 28 pages", desc: "Full product development: design, engineering, certification." },
  { name: "Technical Catalogue", type: "PDF · 96 pages", desc: "Dimensional data, electrical diagrams, installation references." },
  { name: "Certificates Pack", type: "ZIP · PDF set", desc: "EN 81-40, CE declarations and quality certifications." },
  { name: "Media Kit", type: "ZIP · 240 MB", desc: "Press releases, brand story and editorial imagery." },
  { name: "Logo Pack", type: "ZIP · SVG / PNG", desc: "ACTIVE, CDRIVE™ and WSAFE™ marks in all formats." },
  { name: "CAD Files", type: "STEP / DWG", desc: "Rail profiles and product geometry for specifiers." },
  { name: "Image Library", type: "ZIP · 4K renders", desc: "Product renders and photography for dealer marketing." },
  { name: "Video Library", type: "MP4 · 4K", desc: "Product films, technology explainers and factory footage." },
];

export const NEWS = [
  {
    slug: "cdrive-unveiled",
    category: "Technology",
    date: "2026-05-12",
    title: "ACTIVE unveils CDRIVE™, the brushless drive platform behind the world's quietest stairlift",
    excerpt: "Measured at 38 dB in independent testing, CDRIVE™ eliminates brushes, gear noise and vibration — redefining what dealers can promise customers.",
    image: IMAGES.cdrive,
  },
  {
    slug: "outdoor-curved-production",
    category: "Innovation",
    date: "2026-04-03",
    title: "World's only outdoor curved stairlift enters series production",
    excerpt: "WSAFE™-protected and rated from −15°C to +45°C, ACTIVE Outdoor Curved opens a product category distributors have never been able to sell.",
    image: IMAGES.outdoor,
  },
  {
    slug: "european-rail-facility",
    category: "Company",
    date: "2026-03-18",
    title: "ACTIVE commissions European rail manufacturing facility",
    excerpt: "CNC rail bending, powder coating and final assembly under one roof — 15-day curved rail lead times and the foundation for MODULAR RAIL™.",
    image: IMAGES.factory,
  },
  {
    slug: "aimeasure-preview",
    category: "Technology",
    date: "2026-06-02",
    title: "AIMEASURE™ preview: a complete stair survey from smartphone photographs",
    excerpt: "No laser scanner. No expensive equipment. Our AI measurement pipeline turns dealer photography into production-ready rail geometry.",
    image: IMAGES.controlRoom,
  },
  {
    slug: "dealer-network-14-markets",
    category: "Dealer Stories",
    date: "2026-02-20",
    title: "ACTIVE dealer network reaches 14 European markets",
    excerpt: "From Scandinavia to the Mediterranean, distribution partners are building their stairlift business on the ACTIVE platform.",
    image: IMAGES.architecture,
  },
];

export const COUNTRIES = [
  { code: "IT", name: "Italy", lon: 12.5, lat: 42.8, covered: true },
  { code: "DE", name: "Germany", lon: 10.4, lat: 51.1, covered: true },
  { code: "FR", name: "France", lon: 2.3, lat: 46.6, covered: true },
  { code: "UK", name: "United Kingdom", lon: -1.5, lat: 52.8, covered: true },
  { code: "ES", name: "Spain", lon: -3.7, lat: 40.3, covered: true },
  { code: "NL", name: "Netherlands", lon: 5.3, lat: 52.2, covered: true },
  { code: "BE", name: "Belgium", lon: 4.6, lat: 50.6, covered: true },
  { code: "AT", name: "Austria", lon: 14.1, lat: 47.6, covered: true },
  { code: "CH", name: "Switzerland", lon: 8.2, lat: 46.8, covered: true },
  { code: "SE", name: "Sweden", lon: 15.0, lat: 62.0, covered: true },
  { code: "PL", name: "Poland", lon: 19.4, lat: 52.1, covered: true },
  { code: "PT", name: "Portugal", lon: -8.2, lat: 39.6, covered: true },
  { code: "IE", name: "Ireland", lon: -8.0, lat: 53.2, covered: true },
  { code: "DK", name: "Denmark", lon: 10.0, lat: 56.0, covered: true },
  { code: "NO", name: "Norway", lon: 8.8, lat: 63.5, covered: false },
  { code: "FI", name: "Finland", lon: 26.0, lat: 63.0, covered: false },
  { code: "CZ", name: "Czechia", lon: 15.5, lat: 49.8, covered: false },
  { code: "GR", name: "Greece", lon: 22.0, lat: 39.0, covered: false },
  { code: "HR", name: "Croatia", lon: 16.4, lat: 45.1, covered: false },
  { code: "HU", name: "Hungary", lon: 19.5, lat: 47.2, covered: false },
  { code: "RO", name: "Romania", lon: 25.0, lat: 45.9, covered: false },
  { code: "SK", name: "Slovakia", lon: 19.7, lat: 48.7, covered: false },
  { code: "SI", name: "Slovenia", lon: 14.9, lat: 46.1, covered: false },
  { code: "LT", name: "Lithuania", lon: 24.0, lat: 55.4, covered: false },
  { code: "BG", name: "Bulgaria", lon: 25.5, lat: 42.7, covered: false },
  { code: "RS", name: "Serbia", lon: 20.8, lat: 44.0, covered: false },
];

export const COUNTRY_NAMES = COUNTRIES.map((c) => c.name).sort();

export const LEAD_TYPES = [
  { value: "distributor", label: "Become a Distributor" },
  { value: "oem", label: "OEM Manufacturing" },
  { value: "odm", label: "ODM Development" },
  { value: "sales", label: "Sales Enquiry" },
  { value: "technical", label: "Technical Question" },
  { value: "support", label: "Support" },
  { value: "marketing", label: "Marketing / Press" },
  { value: "download", label: "Download Request" },
];
